import { TextField } from '@material-ui/core';
import { Controller, Control, Path, FieldValues } from 'react-hook-form';
import { CostFieldConfig } from '../../config/costStructureFields';
import { handleDecimalPlaces } from 'utils';

type CostFieldInputProps<T extends FieldValues> = {
  field: CostFieldConfig;
  control: Control<T>;
  className?: string;
  required?: boolean;
};

export const CostFieldInput = <T extends FieldValues>({
  field,
  control,
  className,
  required,
}: CostFieldInputProps<T>) => {
  return (
    <Controller
      name={field.source as Path<T>}
      control={control}
      render={({ field: fieldProps, fieldState }) => (
        <TextField
          {...fieldProps}
          id={`${field.source}-input`}
          type="number"
          label={field.label}
          className={className}
          margin="dense"
          variant="filled"
          required={required}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          inputProps={{
            min: field.min,
            max: field.max,
            step: field.step,
          }}
          value={fieldProps.value ?? ''}
          onChange={e => {
            const parsed = handleDecimalPlaces(e.target.value);
            fieldProps.onChange(parsed === '' ? null : parsed);
          }}
        />
      )}
    />
  );
};
